import React from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.ebookComponent.scss';

const Ebookcomponent = ({ data }) => {

    return (
        <div data-sal-duration="800" data-sal="slide-up" data-sal-easing="ease" className="cp-ebookComponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-ebookComponent__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                <div className="cp-ebookComponent__content l--flex" style={{ backgroundColor: `${data.ebookComponentInternalSectionBackgroundColor ? data.ebookComponentInternalSectionBackgroundColor : "#fff"}` }}>
                    <div className="cp-ebookComponent__content-left">
                        {data.ebookComponentTitle &&
                            <h2>{data.ebookComponentTitle}</h2>
                        }
                        {data.ebookComponentContent &&
                            <div dangerouslySetInnerHTML={{ __html: data.ebookComponentContent }} />
                        }
                        {data.ebookComponentLink &&
                            <div className="l-relativeButton">
                                <a href={data.ebookComponentLink.url} target={data.ebookComponentLink.target} rel="noreferrer" className="l-button">
                                    <span>{data.ebookComponentLink.title}</span>
                                    <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                                </a>
                                <a href={data.ebookComponentLink.url} target={data.ebookComponentLink.target} rel="noreferrer" className="l-button l-backgroundHover">
                                    <span>{data.ebookComponentLink.title}</span>
                                    <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                                </a>
                            </div>
                        }
                    </div>
                    <div className="cp-ebookComponent__content-right">
                        {data.ebookComponentImage &&
                            <GatsbyImage image={getImage(data.ebookComponentImage.gatsbyImage)} alt={data.ebookComponentImage.altText} />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Ebookcomponent;